import { useMutation, useQueryClient } from '@tanstack/react-query';
import { activateSchedule } from '@/features/accounts/api';

export function useActivateSchedule() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: activateSchedule,
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['schedules'] }),
  });
}
